import { mapState, mapGetters, mapActions } from 'vuex'
import Loading from '@/components/Core/Loading'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'

export default {
  name: 'TenantDetail',
  components: {
    Loading
  },
  metaInfo () {
    let title = this.categoryName + '管理 | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  props: {
    tenantId: String
  },
  data () {
    return {
      loading: true
    }
  },
  // beforeMount () {
  //   if (this.getPermission('Member')) return
  //   this.$router.push({name: 'Home'})
  // },
  mounted () {
    this.init()
  },
  beforeDestroy () {
    this.resetDetail()
  },
  computed: {
    ...mapState({
      categoryName: state => state.tenant.categoryName,
      // model
      values: state => state.tenantDetail.values
    }),
    ...mapGetters({
      getMeta: 'meta/get',
      permittedView: 'permission/permittedView',
      getValue: 'tenantDetail/getValue',
    })
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      loadModel: 'tenantDetail/loadModel',
      resetDetail: 'tenantDetail/reset',
    }),

    init () {
      this.loading = true

      // パラメータ
      let tenantParams = {
        tenantUuid: this.tenantId
      }

      // データ読出し
      this.loadModel({
        targetId: this.tenantId,
        tenantParams: tenantParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
        })
        .catch(error => {
          this.showError(error || null)
        })
    }
  }
}